export default __webpack_public_path__ + "static/Brunch_Logo-64cd9e724f5a9570f4a7056a093bb0a1.png";